import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFragment, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { updateProject } from '../../actions/checkoutUIActions';
import { isOnProjectPane } from '../../reducers/checkoutPaneReducer';

import styles from './styles/CheckoutSidebarProjectForm.scss';

// components
import { Button } from 'dibs-elements/exports/Button';
import SharedSelectProject from 'dibs-buyer-layout/exports/SharedSelectProject';
import { CheckoutEditValue } from '../../components/shared/CheckoutEditValue';
import { copy } from '../../components/shared/copy';

const CheckoutSidebarProjectForm = props => {
    const [editable, setEditable] = useState(!props.projectId);

    const { viewer: viewerRef, buyer: buyerRef, projectName, projectId } = props;
    const selectedProject = projectId ? { name: projectName, serviceId: projectId } : null;

    const viewer = useFragment(
        graphql`
            fragment CheckoutSidebarProjectForm_viewer on Viewer {
                ...SharedSelectProject_viewer
            }
        `,
        viewerRef
    );

    const buyer = useFragment(
        graphql`
            fragment CheckoutSidebarProjectForm_buyer on User {
                ...SharedSelectProject_user
            }
        `,
        buyerRef
    );

    const onProjectSave = (project, shouldTrack) => {
        const { name = null, serviceId = null } = project || {};
        props.onUpdateProject({
            projectName: name,
            projectId: serviceId,
        });
        // this method is called twice: when selecting project and clicking save button,
        // therefore added a flag `shouldTrack` to avoid double tracking
        if (project && shouldTrack) {
            const action = project.isNewProject
                ? 'added to new project'
                : 'added to existing project';
            trackEvent({
                action,
                category: 'trade features',
                label: 'checkout',
            });
        }
    };

    let content;

    if (editable) {
        content = (
            <div className={styles.container}>
                <div className={styles.inputContainer}>
                    <SharedSelectProject
                        className={styles.selectProjectWrapper}
                        viewer={viewer}
                        user={buyer}
                        clearable
                        modal="checkout"
                        selectedProject={selectedProject}
                        onProjectSelection={project => onProjectSave(project, true)}
                        selectSize="medium"
                    />
                </div>
                <Button
                    dataTn="sidebar-button"
                    onClick={() => {
                        onProjectSave(selectedProject, false);
                        setEditable(false);
                    }}
                    size="medium"
                >
                    <span className={styles.buttonText}>{copy.save}</span>
                </Button>
            </div>
        );
    } else {
        content = (
            <CheckoutEditValue
                value={projectName}
                onClick={() => {
                    setEditable(true);
                }}
                dataTn="project-name-saved"
                emptyValuePlaceholder="No project"
            />
        );
    }

    return SharedSelectProject ? content : null;
};

CheckoutSidebarProjectForm.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyer: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    projectName: PropTypes.string,
    isOnProject: PropTypes.bool.isRequired,
    onUpdateProject: PropTypes.func.isRequired,
};

export default connect(
    ({ transaction, pane }) => ({
        isOnProject: isOnProjectPane(pane),
        projectId: transaction.projectId || '',
        projectName: transaction.projectName || '',
    }),
    {
        onUpdateProject: updateProject,
    }
)(CheckoutSidebarProjectForm);
